export default "__VITE_ASSET__DnYvEdqL__"